/* eslint-disable import/no-anonymous-default-export */
import axiosInstance from "../axios/axios-configuration";
import { CancelToken } from "axios";
import { IUser } from "../shared/interfaces";
import { AddEditUserAoo_Mode } from "../shared/enums";

const controller = 'UsersAoo';




const addUserAoo = (aooId: number, userAoo: IUser, cancelToken?: CancelToken): Promise<IUser> => {
    return axiosInstance.post(`${controller}/${aooId}/AddUserAoo`, userAoo, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const updateUserAoo = (aooId: number, userAoo: IUser, addEditUserMode: AddEditUserAoo_Mode, cancelToken?: CancelToken): Promise<IUser> => {
    return axiosInstance.post(`${controller}/${aooId}/UpdateUserAoo`, userAoo, { cancelToken: cancelToken, params: { addEditUserMode } })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}



export default {
    addUserAoo,
    updateUserAoo,
}
